import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const OuterContainer = styled.div`
  padding: 20px 0px;
  font-size: 21px;
`

const RedContainer = styled.span`
  font-weight: 500;
  color: ${props => props.theme.enigmaRed};
`;

const GreenContainer = styled.span`
  font-weight: 500;
  color: ${props => props.theme.enigmaGreen};
`;


function ThresholdWidget({ model, value, thresholdValue }) {
  const isOverThreshold = value >= thresholdValue;
  const Container = isOverThreshold ? RedContainer : GreenContainer;
  return (
    <OuterContainer>
      Score:{' '}
      <Container>
        {value.toFixed(3).toString()} / {thresholdValue.toFixed(3).toString()}
      </Container>
    </OuterContainer>
  );
}

ThresholdWidget.propTypes = {
  value: PropTypes.number.isRequired,
  thresholdValue: PropTypes.number,
};

ThresholdWidget.defaultProps = {
  thresholdValue: 0.5,
};

export default ThresholdWidget;
